import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

const defaultProps = {
  className: '',
  disabled: false,
};

const Checkbox = ({ className, disabled, checked, onClick }) => (
  <div>
    <button onClick={() => onClick(!checked)} disabled={disabled} className={className}>
      <i className={classNames(
        checked
          ? 'icon-arrows_square_check'
          : 'icon-arrows_square_remove',
      )}
      />
    </button>
  </div>
);

export default Checkbox;

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;




// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.js